import enLang from "./en/default.json";
import cnLang from "./cn/default.json";
import ruLang from "./ru/default.json";
import en from '../components/images/language/en.png';
import cn from '../components/images/language/cn.png';
import ru from '../components/images/language/ru.png';

const locales = {
  defaultLanguage: "en",
  languages: [
    {
      key: "en",
      icon: en,
      name: "English",
      data: enLang
    },
    {
      key: "cn",
      icon: cn,
      name: "中文",
      data: cnLang
    },
    {
      key: "ru",
      icon: ru,
      name: "РУССКИЙ",
      data: ruLang
    }
  ]
};

export default locales;



// WEBPACK FOOTER //
// ./src/locales/index.js